
import { FormGroup, FormControl, FormArray, Validators } from '@angular/forms';


export function getCreateTenantProjectLinkDtoFormGroup() {
return new FormGroup({
    localProjectId: new FormControl<number | undefined>(undefined, [Validators.required]),
    tenantId: new FormControl<number | undefined>(undefined, [Validators.required]),
    externalProjectId: new FormControl<number | undefined>(undefined, [Validators.required]),
    externalProjectNumber: new FormControl<string | undefined>('', [Validators.maxLength(100)]),
    active: new FormControl<boolean | undefined>(true),
})
;
}
      